export interface GuidedAnalysisStep {
  id: string;
  title: string;
  question: string;
  helperText?: string;
}

export interface GuidedAnalysisFlow {
  id: string;
  title: string;
  description: string;
  steps: GuidedAnalysisStep[];
}

export const demoGuidedAnalysis: GuidedAnalysisFlow = {
  id: "analyse-biais-confirmation-1",
  title: "Analyse guidée : biais de confirmation",
  description: "Un petit parcours pour clarifier si tu filtres les infos selon tes croyances.",
  steps: [
    {
      id: "step-a1",
      title: "Décris la situation",
      question: "Quelle est la situation ou l'affirmation que tu évalues ?",
      helperText: "Note quelques phrases simples.",
    },
    {
      id: "step-a2",
      title: "Sources que tu valorises",
      question: "Quelles sources ou infos as-tu retenues en premier ?",
      helperText: "Liste 2 à 3 sources qui vont dans ton sens.",
    },
    {
      id: "step-a3",
      title: "Sources contradictoires",
      question: "As-tu des sources qui contredisent ton idée ? Lesquelles ?",
      helperText: "Si non, note-en au moins une à consulter.",
    },
    {
      id: "step-a4",
      title: "Impact sur ton avis",
      question: "Qu'est-ce que ces sources opposées changent dans ton avis ?",
    },
    {
      id: "step-a5",
      title: "Action simple",
      question: "Quelle action concrète vas-tu faire pour équilibrer ton point de vue ?",
      helperText: "Ex: lire un article opposé, discuter avec quelqu'un qui n'est pas d'accord.",
    },
  ],
};
